import { AxiosApi } from "api";
import { FilterOption } from "interface";
import { ReleasePackage,PackagesNotReleased, PackageLine } from "interface/package";
import { ApiResponse } from "interface/response";
import { useInfoStore } from "store/error";

export interface ReleasedPackageFilter extends Omit<FilterOption, "vesselRegistrationNumber"> {
    vesselRegistrationId?: string;
    buyerLedgerAccountNumber?: string;
    registrationId?: string;
    vesselId?: string;
    vesselName?: string;
    buyerName?: string;
    terminalId?: string;
    terminalName?: string;
    vesselLedgerAccountNumber?: string;
    // buyerId?: string;
}


export interface PackageLineFilter {
    registrationId?: number;
    packageId: number;
}

export interface PackagesNotReleasedFilter {
    buyerLedgerAccountNumber?: string;
    buyerName?:string
    vesselId?:string
    vesselName?: string
    vesselRegistrationId?: string
    registrationId?:number| null
}

export async function getReleasedPackagesApi(filter: ReleasedPackageFilter) {
    const apiUri = "Packages/Released";
    try {
        const packages = await AxiosApi.get<ApiResponse<ReleasePackage[]>>(apiUri, { params: filter });
        return packages.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
export async function getPackagesNotReleasedApi(filter: PackagesNotReleasedFilter) {
    const apiUri = "Packages/NotReleased";
    try {
        const packages = await AxiosApi.get<ApiResponse<PackagesNotReleased[]>>(apiUri, { params: filter });
        return packages.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getPackageLinesApi(filter: PackageLineFilter) {
    const apiUri = "Packages/PackageLines";
    try {
        const packageLines = await AxiosApi.get<ApiResponse<PackageLine[]>>(apiUri, { params: filter });
        return packageLines.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
